import React from "react";
import "../../styles/css/App.css";
import munic from "../../assets/images/ayacucho/lg.png";
import * as Constants from "../../consts/Constants.js";

import auth from "../../plas/auth/service.jsx";

import TextField from '@mui/material/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { withRouter } from "react-router";
import LoadingButton from '@mui/lab/LoadingButton';

import redirect from "./redirection";
import alerter from "../alerts/alerter";


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  image: {
    width: "300px",
    marginBottom: "15px"
  },
  error: {
    color: "red"
  }
}));

function Login({ history }) {

  const classes = useStyles();
  const [loading, setLoading] = React.useState(null);
  const [invalidPassword, setInvalidPassword] = React.useState(false);
  const [invalidUserName, setInvalidUserName] = React.useState(false);

  const [data, setData] = React.useState({
    userName: "",
    password: "",
  });

  const canLogin = () => {
    return data.userName !== "" && data.password !== "";
  }

  const handleSubmit = (e) => {
    setInvalidPassword(false);
    setInvalidUserName(false);
    setLoading(true);
    auth.createSession(data.userName, data.password, (response) => {
      if (response.result != null) {
        history.push(redirect.getIndexByRoles(auth.getUser().additionalRoles));
      } else {
        let descriptor = response.error.descriptor;
        if (descriptor) {
          if (descriptor === "Auth.InvalidPassword") {
            setInvalidPassword(true);
          } else if (descriptor === "Auth.InvalidUserName") {
            setInvalidUserName(true);
          } else {
            alerter.showError(response.error);
          }
        }
      }
      setLoading(false);
    })
  };

  const handleChange = (e) => {
    setInvalidPassword(false);
    setInvalidUserName(false);
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <img src={munic} alt="Municipalidad de Ayacucho" className={classes.image} />
        <Typography component="h1" variant="h5">
            Iniciar sesión
          </Typography>

          <form className={classes.form} noValidate>

            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="userName"
              label="Nombre de usuario"
              name="userName"
              autoComplete="userName"
              error={invalidUserName}
              helperText={invalidUserName ? "El usuario no existe" : " "}
              onChange={handleChange}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              error={invalidPassword}
              style={{'marginTop': '0px'}}
              helperText={invalidPassword ? "La contraseña es incorrecta" : " " }
              type="password"
              id="password"
              onChange={handleChange}
            />
          </form>

          <LoadingButton
            style={{'background': Constants.COLOR_PRIMARY, 'marginTop': '8px'}}
            fullWidth
            loading={loading}
            disabled={!canLogin()}
            className={classes.submit}
            loadingPosition="start"
            variant="contained"
            onClick={handleSubmit}>
            Ingresar
          </LoadingButton>

      </div>

    </Container>
  );
}

export default withRouter(Login);